import { createGetEndpoint } from '@sonar-software/sonar-http';

export const getExchangeOidcToken =
	createGetEndpoint<void, { localUserIdToken: string }>('/api/v3/security/authentication/exchange-oidc-token');
